import styled from 'styled-components';

export const ToggleSwitch = styled.label`
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sm};
  cursor: pointer;
  user-select: none;
`;

export const ToggleInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
`;

export const ToggleSlider = styled.span`
  position: relative;
  cursor: pointer;
  width: 44px;
  height: 24px;
  background-color: ${props => props.$checked ? props.theme.colors.tint : props.theme.colors.border};
  border-radius: 34px;
  transition: .4s;

  &:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: .4s;
    border-radius: 50%;
    transform: ${props => props.$checked ? 'translateX(20px)' : 'translateX(0)'};
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  }
`;
